/* eslint-disable prettier/prettier */
import { Button, ButtonProps } from "@mui/material";
import { ctaButtonSx, secondaryButtonSx } from "./buttonStyles";

interface ICommonButton extends ButtonProps {
  title: string;
  // Accepted for older callers but never drawn: text buttons carry no icon.
  icon?: React.ReactElement;
  place?: string;
}

const CommonButton: React.FC<ICommonButton> = ({
  title,
  icon,
  place, // Optional: remove if not used
  onClick,
  disabled = false,
  color = "info",
  variant = "contained",
  sx,
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      color={color}
      variant={variant}
      disabled={disabled}
      className="CommonButton-root fs-14"
      // House look: a filled button is the orange primary, anything else the dark secondary.
      sx={[variant === "contained" ? ctaButtonSx : secondaryButtonSx, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    >
      {title}
    </Button>
  );
};

export default CommonButton;
